import '@/assets/css/common.css'
//import '@/assets/scss/common.scss'
import '@/assets/css/font.css'
import '@/assets/css/motion.css'
import '@/assets/css/ir.css'
import 'vue-resize/dist/vue-resize.css'
import 'slick-carousel/slick/slick.css'
import Vue from 'vue'
import VueScrollStop from 'vue-scroll-stop'
import VueTouch from 'vue-touch'
import App from './App.vue'
import VueResize from 'vue-resize'
import device from "vue-device-detector"
import Slick from 'vue-slick';

// 테스트
// Vue.use(VueScrollStop)
Vue.use(VueResize)
Vue.use(device)
Vue.use(VueTouch);
Vue.config.productionTip = false
Vue.component('Slick' , Slick)
Vue.prototype.$BACKEND_PATH = process.env.NODE_ENV == 'development' ? '//dev.gnmpm.com':''
Vue.filter('filter_length' , (v,l) =>{
  let ln = l?l:1000
  let sv = v.slice(0,ln)
  return sv
})

new Vue({
  render: h => h(App),
}).$mount('#app')
